{
  "created": "Property successfully created.",
  "updated": "Property successfully updated.",
  "removed": "Property successfully removed.",
  "remove-property": "Remove Property",
  "remove-confirmation": "Are you sure you want to remove the property?",
  "hard-remove-confirmation": "Mortgage payoffs, loans and taxes associated with this property will be deleted, are you sure you want to remove the property?\nRemoval may take some time",
  "earnest-money":"Earnest Money",
  "selling-commission":"Selling Commission",
  "listing-commission":"Listing Commission",
  "selling-commission-percent":"Selling Commission Percent",
  "listing-commission-percent":"Listing Commission Percent",
  "accounting-entries-updated":"Accounting Entries Updated",
  "error-delete-proration": "Unexpected error occurred while trying to delete the proration",
  "error-delete-mortgage": "Unexpected error occurred while trying to delete the mortgage payoff",
  "error-delete-loan": "Unexpected error occurred while trying to delete the loan",
  "property-must-be-created-first": "The property must be created first",
  "provide-required-info": "Please provide all the required information."
}